import { Routes, Route, Navigate, RouterProvider } from 'react-router-dom';
import { FichaScreen } from '../components/ficha/FichaScreen';

import { LoginPage } from '../components/pages/Login';
import { FichaProvider } from '../context/FichaContext';

import { MiddleRoute } from './MiddleRoute';

export const AuthRouter = () => {
	return (
		<Routes>
			<Route
				path="login"
				element={
					<MiddleRoute>
						<LoginPage />
					</MiddleRoute>
				}
			/>

			<Route
				path="singup"
				element={
					<FichaProvider>
						<FichaScreen />
					</FichaProvider>
				}
			/>
			<Route path="/*" element={<Navigate to="singup" />} />
		</Routes>
	);
};
